import { render, staticRenderFns } from "./CouponListView.vue?vue&type=template&id=187a2230&scoped=true"
import script from "./CouponListView.vue?vue&type=script&lang=js"
export * from "./CouponListView.vue?vue&type=script&lang=js"
import style0 from "./CouponListView.vue?vue&type=style&index=0&id=187a2230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187a2230",
  null
  
)

export default component.exports